import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
  ListGroupItem,
  Row,
  Col,
  Button,
  Badge
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import { INVITATION_STATUSES } from '../../../config/constants';

class NotificationComponent extends Component {
  updateInvitation(status) {
    this.props.updateInvitation(this.props.notification.id, status);
  }

  calculateDate(createdDate) {
    let now = moment(new Date());
    let duration = moment.duration(-now.diff(moment(createdDate))).humanize(true);

    return <Fragment>
      <FontAwesomeIcon
        size="sm"
        className="mr-1"
        icon={faClock}
      />
      {`${duration} `}
    </Fragment>
  }

  render() {
    const { index } = this.props;
    return (
      <ListGroupItem
        className="list-group-item-action pt-3"
        id={"notification-" + index}
      >
        <Row className="pl-2">
          <Row className="notification-bullet-point">&nbsp;</Row>
          <Col>
            <Row>
              <p className="mb-0 text-sm font-weight-normal notification-invitation-text">
                <FormattedMessage id="messages.invitation_request" />
                <strong>{` ${this.props.notification.organizationName} `}</strong>
                <FormattedMessage id="messages.invitation_request_by" />
                <strong>{` ${this.props.notification.invitedBy}`}</strong>
              </p>
            </Row>
            <Row className="pt-3">
              {this.props.notification.status === INVITATION_STATUSES.PENDING &&
                <div>
                  <Button id="btnAccept" color="primary" type="button" size="sm" onClick={() => this.updateInvitation(2)}>
                    <FormattedMessage id="messages.accept" />
                  </Button>
                  <Button id="btnDecline" color="secondary" type="button" size="sm" onClick={() => this.updateInvitation(1)}>
                    <FormattedMessage id="messages.decline" />
                  </Button>
                </div>
              }
              {
                this.props.notification.status === INVITATION_STATUSES.ACCEPTED &&
                <Badge color="primary" pill>
                  <FormattedMessage id="messages.accepted" />
                </Badge>
              }
              {
                this.props.notification.status === INVITATION_STATUSES.REJECTED &&
                <Badge color="secondary" pill>
                  <FormattedMessage id="messages.rejected" />
                </Badge>
              }
            </Row>
          </Col>
          <Row className="text-muted w-30 m-0 pr-2 justify-content-end text-right">
            <small>{ this.props.notification.sent_at && this.calculateDate(this.props.notification.sent_at) }</small>
          </Row>
        </Row>
      </ListGroupItem>
    )
  }
}

NotificationComponent.defaultProps = {
  notification: {},
  index: 0
};

const mapStateToProps = state => ({
  language: state.locale.lang
});

const Notification = connect(mapStateToProps, { updateInvitation: () => console.log('updateInvitation') })(NotificationComponent);
export { Notification };
